import { useEffect, useRef, useState } from "react";
import Button from "../../../components/design/buttons/Button";
import './Payment.css'
import { Card, Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { createAccount, loginAccount, verifyCode } from "../../../services/accounts.service";
import React from "react";
import { toast } from "react-toastify";
import SideInfo from "./sideInfo";
import { Info } from "./PlanItem";
import { getCountryById, getProviderById } from "../../../services/providers.service";
import { getPlanById } from "../../../services/plans.service";
import Header from "../../../components/header/header";
import Footer from '../../../components/footer/footer';
import { REACT_APP_API_ESIM, REACT_APP_API_PAYMENT, REACT_APP_API_PAYMENTS } from '../../../../config';
import axios from "axios";
import PaymentSec from "./PaymentSec";
import { handleDataLayer } from "../../../tools/AssetHelpers";

const Payment = (
) => {
    const id = useParams().id;
    const itemId = useParams().item;

    const [selected, setSelected] = useState(0);
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const [state, setState] = useState<any>("register");
    const isMobile = window.innerWidth < 992;
    const [country, setCountry] = React.useState<any>(null);
    const [plan, setPlan] = React.useState<any>(null);
    const [user, setUser] = useState<any>(localStorage.getItem("tygo_user"));
    const [promoCode, setPromoCode] = React.useState<any>(
        new URL(window.location.href).searchParams.get('promoCode')
    );
    const getCountry = () => {
        getCountryById(+id!, i18n.language).then((dat: any) => {
            setCountry(dat.returnData);
        });
    }

    const getPlan = () => {
        getPlanById(+itemId!, i18n.language).then(async (dat: any) => {
            const provider = await getProviderById(dat.returnData.providerId, i18n.language).then
            ((d: any) => {
                return d.returnData;
            });
            const newDat = {
                ...dat.returnData,
                provider
            }
        
            setPlan(newDat);
            console.log(newDat);
        });
    }

    
    React.useEffect(() => {
        if (id) {
            getCountry();
        } 
        if (itemId) {
            getPlan();
        }

    }, [id, itemId]);

    useEffect(() => {
        setUser(localStorage.getItem("tygo_user"));
        if(user && JSON.parse(user).token) {
            handleDataLayer("payment_page", "user", "user_visited_payment_page", "user_visited_payment_page");
            setState("card");
        } else {
            //redirect the user to 
            http://localhost:3000/login2?redirect=/sim?id=964
            navigate("/login2?redirect=/store/" + id + "/" +itemId);
            handleDataLayer("login_page", "user", "user_visited_login_page", "user_visited_login_page");
        }

    }, []);
    const [method, setMethod] = useState<string>("Email");


    return (
        <>
        <div className="payment__section">
            <div className="container">
            <Header />
                <div className="row">
                    
                    <div className="col-md-8">
                    
                           
                <div className="mt-md-5 pe-md-5 mt-3">
            {
                // state === "cupon" ? <></>
                // : 
                state === "register" || state === "otp" ? <RegisterForm setState={setState} setMethod={setMethod} method={method} />
                // : state === "otp" ? <OtpForm setState={setState} />
                : state === "card" && plan ?
                <PaymentSec
                    plan={plan}
                    isTest={
                        REACT_APP_API_ESIM === "https://test.esim.tygo.net" ?
                        true : false
                    }
                ></PaymentSec>
            // <CardForm 
            // entityType="APPLEPAY"
            // amount={plan?.price}
            // email="test@test.com"
            // street="street"
            // city="city"
            // state="state"
            // country="SA"
            // postcode="test"
            // givenName="givenName"
            // surname="surname"
            // phoneNumber="1234567890"
            // countryCode="966"
            // paymentFor="string"
            // promoCode={promoCode}
            // isMobile={isMobile}
            // products={[plan]}
            // isApp={false}
            // />
            : <></>
            }
            <Modal show={state === "otp"} onHide={() => setState("register")} className="modal_store_info" style={
                {
                    direction: i18n.language === "ar" ? "rtl" : "ltr"
                }
            }>
                <Modal.Header className="order-header" closeButton  style={{
                        border: "none",
                        padding: "0",
                        width: "100%"
                    }}>
                <Modal.Title>{t('store.otp.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OtpForm setState={setState} method={method} />
                </Modal.Body>
            </Modal>
            </div>
                    </div>

            {/* <div className={"mt-0 mt-lg-5 col-md-4 " + (state === "cupon" ? "" : 
                isMobile ? "d-none" : "")}>
            <SideInfo 
                        background={country?.countryImageURL?
                            country?.countryImageURL
                               :
                           "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Antu_nmap.svg/1920px-Antu_nmap.svg.png"
                       } noBg={[1,5]}
                       is_bg={country?.countryImageURL ? true : false}
                        elements={[
                            <div className="plan-item m-0 p-0">
                                <h3 
                                >{plan?.name}</h3>
                                <span className='price_item'>{plan?.price} {t('global.sar')}</span>
                                <div className="d-flex  gap-2 mt-4">
                                <Info name={t('details.validity')}
                                 logo="/media/svgs/clock_.svg" info={plan?.validityTimeInDays + " " + t('plans.days')} />
                                <Info name= {t('store.network')} logo="/media/svgs/rss.svg" info={plan?.coverage}/>
                                </div>
                            </div>,
                            (user && JSON.parse(user).token) ?
                            <div className="d-flex promo_code justify-content-between align-items-center">
                                <img src="/media/svgs/tag_.svg" />
                                <input type="text" placeholder={t("store.add_promo_code")+""} className="form-control" style={{    border: "none"}} id="promoCode" />
                                <span onClick={
                                    async () => {
                                        const url = new URL(window.location.href);
                                        const input = document.getElementById("promoCode") as HTMLInputElement;
                                        const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');

                                        try{
                                            const res = await axios(`${REACT_APP_API_PAYMENTS}/api/v2/PromoCode/GetPromoDataByCode?promoCode=${input.value}`
                                                , {
                                                    headers: {
                                                        Authorization: `Bearer ${user.token}`
                                                    }
                                                }
                                                );
                                                const data = await res.data;
                                                if (data.isValid) {
                                                    toast.success("Valid promo code");
                                                    url.searchParams.set("promoCode", input.value);
                                                    window.location.href = url.href;
                                                    setPromoCode(input.value);
                                                } else {
                                                    toast.error("Invalid promo code");
                                                }
                                        } catch(e:any) {
                                            toast.error(e.toString());
                                        }
                                    }
                                } style={{cursor:"pointer"}}>
                                    {t('store.submit')}
                                </span>
                            </div>: 
                            <></>,
                            <div className="table_info">
                                <div className="d-flex title_item align-items-center gap-2">
                                    <img src="/media/svgs/list.svg" />
                                    <h6 className='m-0'>{t('store.order_details')}</h6>
                                </div>
                                <div className="d-flex justify-content-between table_item">
                                    <span>{t('store.price')}</span>
                                    <span>{plan?.price} {t('global.sar')}</span>
                                </div>
                                <div className="d-flex justify-content-between table_item">
                                    <span>{t('store.quantity')}</span>
                                    <span>1</span>
                                </div>
                                <div className="d-flex justify-content-between table_item">
                                    <span>{t('store.fees')}</span>
                                    <span>0 {t('global.sar')}</span>
                                </div>
                                <div className="devider"></div>
                                <div className="d-flex justify-content-between ">
                                    <span>{t('store.total')}</span>
                                    <strong className='c-primary'>{plan?.price} {t('global.sar')}</strong>
                                </div>
                            </div>,
                            
                            
                                

                            
                        ]}
                        />

                            <div className='py-0 px-4'>
                            <div className="p-3">
                                <svg  width="" height="29" viewBox="0 0 381 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_510_828)">
                                    <path d="M14.761 19.2792H12.015L13.731 8.72864H16.478L14.761 19.2792ZM9.70396 8.72864L7.08498 15.9854L6.77496 14.4227L5.85097 9.67854C5.85097 9.67854 5.73897 8.72864 4.54797 8.72864H0.218964L0.167969 8.90724C0.167969 8.90724 1.49197 9.18274 3.04097 10.1131L5.42796 19.2795H8.28996L12.66 8.72864H9.70396ZM31.309 19.2792H33.832L31.632 8.72834H29.424C28.405 8.72834 28.156 9.51464 28.156 9.51464L24.06 19.2792H26.923L27.496 17.712H30.988L31.309 19.2792ZM28.287 15.5471L29.73 11.5988L30.542 15.5471H28.287ZM24.274 11.2657L24.666 9.00014C24.666 9.00014 23.457 8.54004 22.196 8.54004C20.833 8.54004 17.596 9.13584 17.596 12.0328C17.596 14.7585 21.395 14.7924 21.395 16.2241C21.395 17.6558 17.987 17.3993 16.862 16.4965L16.454 18.8654C16.454 18.8654 17.68 19.4612 19.554 19.4612C21.429 19.4612 24.257 18.4906 24.257 15.849C24.257 13.1058 20.423 12.8504 20.423 11.6578C20.424 10.4648 23.099 10.618 24.274 11.2657Z" fill="#2566AF"/>
                                    <path d="M6.77496 14.4227L5.85097 9.67803C5.85097 9.67803 5.73897 8.72803 4.54797 8.72803H0.218964L0.167969 8.90673C0.167969 8.90673 2.24896 9.33793 4.24496 10.9536C6.15296 12.498 6.77496 14.4227 6.77496 14.4227Z" fill="#E6A540"/>
                                    <path d="M60.5 22V6" stroke="#E8E8E8"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M105.008 21.6083C106.807 23.2655 109.222 24.2707 111.849 24.2707C117.492 24.2707 122.058 19.6688 122.058 14.0088C122.058 8.3316 117.492 3.72949 111.849 3.72949C109.222 3.72949 106.807 4.7345 105.008 6.3919C102.945 8.2785 101.641 10.9938 101.641 14.0088C101.641 17.0238 102.945 19.7394 105.008 21.6083Z" fill="#E9B040"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M120.701 19.7216C120.701 19.5452 120.842 19.4043 121.018 19.4043C121.212 19.4043 121.353 19.5454 121.353 19.7216C121.353 19.9158 121.212 20.0567 121.018 20.0567C120.842 20.0567 120.701 19.9158 120.701 19.7216ZM121.018 19.9864C121.16 19.9864 121.283 19.8627 121.283 19.7218C121.283 19.5809 121.159 19.4751 121.018 19.4751C120.895 19.4751 120.772 19.5809 120.772 19.7218C120.772 19.8627 120.895 19.9864 121.018 19.9864ZM120.983 19.8805H120.913V19.5807H121.036C121.054 19.5807 121.089 19.5807 121.106 19.5985C121.142 19.616 121.142 19.6338 121.142 19.6691C121.142 19.7044 121.124 19.7396 121.089 19.7396L121.16 19.8808H121.071L121.036 19.7571H120.983V19.8805V19.7042H121.054C121.071 19.7042 121.071 19.6863 121.071 19.6689C121.071 19.651 121.071 19.651 121.054 19.6336H120.983V19.8805Z" fill="#E9B040"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M108.306 12.9158C108.271 12.5456 108.2 12.193 108.13 11.8226H101.888C101.959 11.4524 102.064 11.0998 102.17 10.7471H107.83C107.707 10.3759 107.566 10.011 107.407 9.6539H102.611C102.787 9.2804 102.982 8.9156 103.193 8.5607H106.808C106.575 8.1841 106.316 7.8247 106.032 7.4851H103.969C104.288 7.0954 104.636 6.73 105.009 6.3919C103.193 4.7521 100.795 3.72949 98.1504 3.72949C92.5264 3.72949 87.9414 8.3316 87.9414 14.0088C87.9414 19.6688 92.5264 24.2707 98.1504 24.2707C100.795 24.2707 103.193 23.2655 105.009 21.6083C105.377 21.2761 105.719 20.9165 106.032 20.5325H103.969C103.686 20.1799 103.44 19.8274 103.193 19.4393H106.808C107.035 19.0906 107.235 18.7252 107.407 18.3461H102.611C102.452 17.9935 102.294 17.641 102.17 17.2703H107.83C107.953 16.9178 108.042 16.5478 108.129 16.1771C108.2 15.8246 108.271 15.4546 108.306 15.084C108.342 14.7265 108.359 14.3674 108.359 14.0082C108.359 13.6386 108.341 13.2684 108.306 12.9158Z" fill="#CC2131"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M120.701 16.3894C120.701 16.1956 120.842 16.0547 121.018 16.0547C121.212 16.0547 121.353 16.1958 121.353 16.3894C121.353 16.5658 121.212 16.7246 121.018 16.7246C120.842 16.7246 120.701 16.5656 120.701 16.3894ZM121.018 16.6361C121.16 16.6361 121.283 16.5303 121.283 16.3894C121.283 16.2485 121.159 16.1427 121.018 16.1427C120.895 16.1427 120.772 16.2485 120.772 16.3894C120.772 16.5303 120.895 16.6361 121.018 16.6361ZM120.983 16.5303H120.913V16.2483H121.106C121.142 16.2661 121.142 16.3014 121.142 16.3367C121.142 16.3541 121.124 16.3894 121.089 16.4073L121.16 16.5305H121.071L121.036 16.4247H120.983V16.5303V16.3718H121.018C121.036 16.3718 121.054 16.3718 121.054 16.3539C121.071 16.3539 121.071 16.3365 121.071 16.3186C121.071 16.3186 121.071 16.3012 121.054 16.3012C121.054 16.2834 121.036 16.3012 121.018 16.3012H120.983V16.5303Z" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M101.535 16.9709C101.201 17.0589 100.954 17.112 100.707 17.112C100.178 17.112 99.8597 16.7769 99.8597 16.1773C99.8597 16.0541 99.8778 15.9306 99.8958 15.7895L99.9658 15.3842L100.019 15.0491L100.495 12.1575H101.553L101.43 12.7923H102.1L101.941 13.8503H101.271L100.989 15.578C100.971 15.6664 100.971 15.7191 100.971 15.7544C100.971 15.9837 101.077 16.0717 101.341 16.0717C101.465 16.0717 101.571 16.0543 101.676 16.0364L101.535 16.9709ZM104.956 16.9356C104.568 17.0414 104.216 17.0942 103.828 17.0942C102.629 17.0942 101.941 16.4594 101.941 15.2078C101.941 13.7442 102.752 12.6863 103.88 12.6863C104.78 12.6863 105.361 13.2858 105.361 14.2201C105.361 14.5378 105.326 14.8374 105.238 15.2605H103.034C103.017 15.3311 103.017 15.3664 103.017 15.4016C103.017 15.8953 103.351 16.1421 103.986 16.1421C104.392 16.1421 104.744 16.0541 105.132 15.8779L104.956 16.9356ZM104.304 14.4143V14.2026C104.304 13.8501 104.11 13.656 103.775 13.656C103.422 13.656 103.175 13.9204 103.069 14.4141L104.304 14.4143ZM93.0717 17.0236H91.9788L92.6138 13.0214L91.1858 17.0236H90.4278L90.3387 13.0391L89.6688 17.0236H88.5938L89.4578 11.8224H91.0618L91.0967 15.0316L92.1728 11.8224H93.9358L93.0717 17.0236ZM95.7347 15.1373C95.6287 15.1194 95.5938 15.1194 95.5228 15.1194C94.8878 15.1194 94.5708 15.3662 94.5708 15.7542C94.5708 16.0188 94.7297 16.1952 94.9767 16.1952C95.5047 16.1952 95.7167 15.7542 95.7347 15.1373ZM96.6158 17.0236H95.6638L95.6818 16.583C95.4348 16.9178 95.0998 17.0942 94.5178 17.0942C93.9888 17.0942 93.5308 16.6183 93.5308 15.9306C93.5308 15.7368 93.5657 15.5606 93.6187 15.3842C93.7947 14.7316 94.4478 14.3263 95.4528 14.3085C95.5758 14.3085 95.7698 14.3085 95.9458 14.3263C95.9808 14.1852 95.9807 14.1321 95.9807 14.0441C95.9807 13.7619 95.7518 13.6737 95.2408 13.6737C94.9238 13.6737 94.5708 13.7266 94.3238 13.8148L94.1648 13.8501L94.0948 13.8675L94.2538 12.9154C94.7648 12.7566 95.1347 12.6863 95.5407 12.6863C96.4927 12.6863 97.0038 13.1271 97.0038 13.938C97.0038 14.1497 97.0217 14.3085 96.9507 14.7669L96.7047 16.2832L96.6688 16.5478L96.6518 16.7594L96.6338 16.9005L96.6158 17.0236ZM110.281 12.8274C110.598 12.8274 110.881 12.9156 111.268 13.1094L111.462 11.981C111.356 11.928 111.321 11.928 111.18 11.8751L110.74 11.7516C110.599 11.7164 110.422 11.6987 110.228 11.6987C109.681 11.6987 109.364 11.7164 109.029 11.9104C108.853 12.0339 108.624 12.1926 108.377 12.4746L108.236 12.4394L107.107 13.2327L107.16 12.7919H105.996L105.309 17.0234H106.42L106.825 14.7492C106.825 14.7492 106.984 14.4315 107.055 14.3261C107.266 14.0615 107.442 14.0615 107.672 14.0615H107.76C107.723 14.3302 107.705 14.6012 107.707 14.8725C107.707 16.2477 108.483 17.1118 109.682 17.1118C109.981 17.1118 110.246 17.0765 110.651 16.9707L110.846 15.7719C110.493 15.9657 110.176 16.0539 109.911 16.0539C109.259 16.0539 108.871 15.5602 108.871 14.7845C108.87 13.6384 109.452 12.8274 110.281 12.8274ZM119.643 11.8224L119.397 13.3035C119.132 12.898 118.815 12.7039 118.391 12.7039C117.809 12.7039 117.263 13.0389 116.928 13.6737V13.6562L116.223 13.2329L116.293 12.7921H115.112L114.442 17.0236H115.535L115.905 14.7494C115.905 14.7494 116.187 14.4317 116.258 14.3263C116.434 14.1146 116.611 14.0791 116.752 14.0617C116.628 14.4143 116.558 14.8374 116.558 15.3137C116.558 16.3716 117.104 17.0767 117.915 17.0767C118.321 17.0767 118.638 16.9356 118.938 16.6005L118.885 17.0236H119.926L120.772 11.8224H119.643ZM118.286 16.0188C117.915 16.0188 117.722 15.7368 117.722 15.19C117.722 14.3612 118.074 13.7619 118.585 13.7619C118.973 13.7619 119.167 14.0617 119.167 14.5907C119.167 15.4369 118.815 16.0188 118.286 16.0188ZM113.19 15.1373C113.085 15.1194 113.049 15.1194 112.979 15.1194C112.344 15.1194 112.026 15.3662 112.026 15.7542C112.026 16.0188 112.185 16.1952 112.432 16.1952C112.961 16.1952 113.173 15.7542 113.19 15.1373ZM114.072 17.0236H113.102L113.137 16.583C112.891 16.9178 112.555 17.0942 111.974 17.0942C111.427 17.0942 110.951 16.6357 110.951 15.9306C110.951 14.9258 111.709 14.3087 112.908 14.3087C113.032 14.3087 113.225 14.3087 113.384 14.3265C113.42 14.1854 113.437 14.1323 113.437 14.0443C113.437 13.7621 113.208 13.6739 112.679 13.6739C112.379 13.6739 112.009 13.7268 111.762 13.815L111.621 13.8503L111.551 13.8677L111.709 12.9156C112.221 12.7569 112.591 12.6865 112.996 12.6865C113.948 12.6865 114.442 13.1273 114.442 13.9382C114.442 14.1499 114.477 14.3087 114.389 14.7671L114.16 16.2834L114.125 16.548L114.09 16.7596L114.072 16.9007V17.0236ZM98.9258 13.6913C99.1378 13.6913 99.4368 13.7089 99.7548 13.7619L99.9138 12.7745C99.5958 12.7392 99.1728 12.6863 98.9258 12.6863C97.6918 12.6863 97.2858 13.3564 97.2858 14.1321C97.2858 14.6436 97.5147 15.0136 98.1147 15.2956C98.5557 15.5073 98.6258 15.5423 98.6258 15.7366C98.6258 16.0007 98.3968 16.1597 97.9738 16.1597C97.6388 16.1597 97.3207 16.1066 96.9688 15.9833L96.8448 16.9528L96.8628 16.9707L97.0748 17.006C97.1448 17.0234 97.2328 17.0412 97.3568 17.0587C97.6208 17.0765 97.8498 17.0939 97.9918 17.0939C99.2258 17.0939 99.7368 16.6181 99.7368 15.6835C99.7368 15.1018 99.4547 14.7492 98.9077 14.5025C98.4317 14.2906 98.3788 14.2557 98.3788 14.0615C98.3788 13.8677 98.5908 13.6913 98.9258 13.6913Z" fill="#1B3771"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M111.763 11.6462L111.569 12.7747C111.181 12.5807 110.899 12.4927 110.581 12.4927C109.752 12.4927 109.171 13.3036 109.171 14.4498C109.171 15.2433 109.559 15.7191 110.211 15.7191C110.475 15.7191 110.793 15.6311 111.146 15.455L110.952 16.6359C110.546 16.7418 110.282 16.7949 109.982 16.7949C108.783 16.7949 108.042 15.9308 108.042 14.5382C108.042 12.6867 109.065 11.3818 110.528 11.3818C110.722 11.3818 110.898 11.3995 111.04 11.4348L111.48 11.5406C111.622 11.5935 111.657 11.6111 111.763 11.6462ZM108.201 12.4221H108.095C107.725 12.4221 107.514 12.5985 107.178 13.1096L107.284 12.4572H106.279L105.592 16.6889H106.703C107.108 14.097 107.214 13.6562 107.743 13.6562H107.813C107.919 13.1449 108.06 12.7745 108.237 12.4395L108.201 12.4221ZM101.819 16.6359C101.519 16.7418 101.272 16.7771 101.025 16.7771C100.461 16.7771 100.143 16.4598 100.143 15.8428C100.143 15.737 100.161 15.5961 100.179 15.4724L100.249 15.0493L100.302 14.7145L100.778 11.8226H101.871L101.748 12.4574H102.312L102.171 13.4977H101.607L101.307 15.2609C101.29 15.3315 101.29 15.3846 101.29 15.4373C101.29 15.649 101.395 15.7372 101.66 15.7372C101.783 15.7372 101.889 15.7372 101.959 15.7019L101.819 16.6359ZM97.5687 13.7973C97.5687 14.3265 97.8157 14.6965 98.3977 14.9787C98.8557 15.1904 98.9267 15.2607 98.9267 15.4371C98.9267 15.7017 98.7327 15.825 98.2917 15.825C97.9567 15.825 97.6567 15.7723 97.3047 15.6664L97.1457 16.6359L97.1987 16.6538L97.3927 16.6891C97.4627 16.7065 97.5517 16.7243 97.6917 16.7243C97.9387 16.7596 98.1507 16.7596 98.2917 16.7596C99.4557 16.7596 100.002 16.3186 100.002 15.3491C100.002 14.767 99.7727 14.4319 99.2267 14.1677C98.7507 13.9561 98.6977 13.9034 98.6977 13.7093C98.6977 13.4802 98.8917 13.3744 99.2437 13.3744C99.4557 13.3744 99.7557 13.392 100.038 13.4273L100.196 12.4576C99.9137 12.4047 99.4737 12.3694 99.2267 12.3694C97.9917 12.3692 97.5517 13.0216 97.5687 13.7973ZM120.209 16.6891H119.168L119.221 16.2834C118.921 16.6007 118.604 16.7418 118.198 16.7418C117.387 16.7418 116.858 16.0545 116.858 14.9966C116.858 13.5859 117.687 12.3868 118.657 12.3868C119.098 12.3868 119.415 12.5809 119.715 12.9687L119.962 11.4877H121.055L120.209 16.6891ZM118.586 15.7017C119.098 15.7017 119.45 15.1022 119.45 14.2734C119.45 13.7268 119.256 13.4445 118.868 13.4445C118.375 13.4445 118.005 14.0264 118.005 14.8552C118.005 15.4197 118.198 15.7017 118.586 15.7017ZM105.204 16.6007C104.816 16.7243 104.463 16.7771 104.058 16.7771C102.823 16.7771 102.189 16.1248 102.189 14.8729C102.189 13.4271 103 12.3516 104.111 12.3516C105.027 12.3516 105.609 12.9511 105.609 13.8855C105.609 14.203 105.574 14.5029 105.468 14.9434H103.282C103.264 14.9966 103.264 15.0318 103.264 15.0671C103.264 15.5608 103.599 15.8075 104.234 15.8075C104.639 15.8075 104.992 15.737 105.38 15.543L105.204 16.6007ZM104.587 14.0793V13.8679C104.587 13.5153 104.393 13.3213 104.058 13.3213C103.705 13.3213 103.458 13.5859 103.352 14.0793H104.587ZM93.3547 16.6891H92.2617L92.8967 12.6865L91.4687 16.6891H90.7097L90.6217 12.7218L89.9517 16.6891H88.9297L89.7937 11.4877H91.3797L91.4327 14.7143L92.4907 11.4877H94.2187L93.3547 16.6891ZM96.0877 14.8023C95.9817 14.8023 95.9287 14.7849 95.8407 14.7849C95.2237 14.7849 94.9067 15.014 94.9067 15.4371C94.9067 15.7017 95.0477 15.8602 95.2947 15.8602C95.7527 15.8602 96.0707 15.4371 96.0877 14.8023ZM96.8987 16.6891H95.9817L95.9997 16.2481C95.7177 16.6007 95.3467 16.7596 94.8357 16.7596C94.2367 16.7596 93.8307 16.3012 93.8307 15.6135C93.8307 14.5734 94.5357 13.9739 95.7697 13.9739C95.8937 13.9739 96.0527 13.9916 96.2287 14.009C96.2637 13.8681 96.2637 13.8152 96.2637 13.7446C96.2637 13.4626 96.0697 13.3568 95.5587 13.3568C95.2417 13.3568 94.8887 13.392 94.6417 13.4626L94.4827 13.5155L94.3767 13.5332L94.5357 12.5811C95.0827 12.4223 95.4527 12.3694 95.8587 12.3694C96.8107 12.3694 97.3217 12.7925 97.3217 13.6035C97.3217 13.8152 97.3037 13.9739 97.2337 14.45L96.9867 15.9489L96.9517 16.213L96.9337 16.4247L96.9157 16.5836L96.8987 16.6891ZM113.544 14.8023C113.42 14.8023 113.367 14.7849 113.297 14.7849C112.662 14.7849 112.345 15.014 112.345 15.4371C112.345 15.7017 112.504 15.8602 112.75 15.8602C113.191 15.8602 113.526 15.4371 113.544 14.8023ZM114.355 16.6891H113.438L113.455 16.2481C113.173 16.6007 112.803 16.7596 112.292 16.7596C111.692 16.7596 111.287 16.3012 111.287 15.6135C111.287 14.5734 111.992 13.9739 113.226 13.9739C113.35 13.9739 113.509 13.9916 113.667 14.009C113.702 13.8681 113.72 13.8152 113.72 13.7446C113.72 13.4626 113.526 13.3568 113.015 13.3568C112.697 13.3568 112.327 13.392 112.08 13.4626L111.939 13.5155L111.833 13.5332L111.992 12.5811C112.539 12.4223 112.909 12.3694 113.315 12.3694C114.267 12.3694 114.76 12.7925 114.76 13.6035C114.76 13.8152 114.76 13.9739 114.672 14.45L114.443 15.9489L114.408 16.213L114.372 16.4247L114.355 16.5836V16.6891ZM117.317 12.4221H117.211C116.841 12.4221 116.629 12.5985 116.294 13.1096L116.4 12.4572H115.395L114.725 16.6889H115.818C116.224 14.097 116.33 13.6562 116.858 13.6562H116.929C117.035 13.1449 117.176 12.7745 117.352 12.4395L117.317 12.4221Z" fill="white"/>
                                    <path d="M148.5 22.5V5.5" stroke="#E8E8E8"/>
                                    <path d="M198.736 17.6171V11.4543H199.781V11.9484C200.099 11.5508 200.571 11.335 201.156 11.335C202.36 11.335 203.224 12.2949 203.224 13.6694C203.224 15.044 202.355 16.021 201.156 16.021C200.565 16.021 200.099 15.7938 199.781 15.3962V17.617L198.736 17.6171ZM199.782 13.1015V14.2376C200.003 14.6977 200.401 15.0328 200.974 15.0328C201.667 15.0328 202.133 14.5159 202.133 13.6639C202.133 12.8233 201.667 12.312 200.974 12.312C200.401 12.3176 200.003 12.6301 199.782 13.1015Z" fill="#02AA7C"/>
                                    <path d="M203.898 14.6229C203.898 13.8731 204.364 13.3506 205.137 13.254L206.915 13.0268V12.8053C206.915 12.5384 206.778 12.3963 206.528 12.3963H204.296V11.4478H206.568C207.471 11.4478 207.965 11.8908 207.965 12.6747V15.8839H206.909V15.3443C206.602 15.776 206.097 16.0202 205.443 16.0202C204.523 16.0202 203.898 15.4579 203.898 14.6229ZM205.699 15.1681C206.233 15.1681 206.727 14.8671 206.909 14.4241V13.8674L205.551 14.0549C205.176 14.106 204.966 14.3048 204.966 14.6286C204.966 14.975 205.233 15.1681 205.699 15.1681Z" fill="#02AA7C"/>
                                    <path d="M208.728 16.6678H209.489C209.779 16.6678 209.91 16.5485 210.006 16.2758L210.142 15.8839L208.529 11.4478H209.62L210.625 14.5377H210.648L211.608 11.4478H212.681L210.915 16.5428C210.676 17.2414 210.358 17.6163 209.58 17.6163H208.728V16.6678Z" fill="#02AA7C"/>
                                    <path d="M176.834 20.6667C178.05 20.6667 179.049 20.2861 179.708 19.65C180.202 19.1614 180.492 18.5026 180.492 17.7415C180.492 17.0542 180.236 16.4351 179.765 15.9636C179.294 15.4921 178.618 15.1457 177.766 14.9809L176.368 14.7083C175.789 14.6004 175.46 14.3107 175.46 13.9074C175.46 13.3792 175.971 13.0157 176.789 13.0157C177.3 13.0157 177.737 13.1804 178.027 13.4701C178.209 13.6689 178.334 13.9245 178.373 14.2141L180.39 13.7597C180.333 13.1804 180.06 12.6691 179.646 12.2489C178.981 11.5956 177.964 11.181 176.766 11.181C175.658 11.181 174.732 11.5446 174.091 12.1239C173.545 12.6351 173.239 13.3224 173.239 14.0892C173.239 14.7594 173.454 15.3274 173.892 15.7591C174.329 16.1965 174.965 16.5203 175.8 16.7247L177.181 17.0541C177.874 17.2189 178.18 17.4745 178.18 17.9289C178.18 18.4912 177.669 18.8206 176.834 18.8206C176.232 18.8206 175.744 18.6218 175.437 18.2923C175.221 18.0765 175.09 17.7812 175.073 17.4574L173 17.9119C173.057 18.531 173.346 19.0763 173.784 19.5136C174.471 20.2349 175.584 20.6667 176.834 20.6667ZM192.181 20.6667C193.528 20.6667 194.561 20.1782 195.271 19.4852C195.834 18.9399 196.18 18.3038 196.362 17.6506L194.238 16.9406C194.147 17.27 193.965 17.6165 193.675 17.8835C193.329 18.2129 192.857 18.4458 192.181 18.4458C191.562 18.4458 190.983 18.2073 190.563 17.7925C190.142 17.3552 189.887 16.7191 189.887 15.9181C189.887 15.1002 190.142 14.4811 190.563 14.0437C190.977 13.6233 191.545 13.4076 192.164 13.4076C192.818 13.4076 193.272 13.6234 193.602 13.9529C193.874 14.2255 194.039 14.572 194.147 14.9184L196.311 14.1914C196.146 13.5553 195.8 12.919 195.294 12.3909C194.567 11.6808 193.511 11.1753 192.113 11.1753C190.824 11.1753 189.66 11.6638 188.825 12.5044C187.99 13.3564 187.479 14.5436 187.479 15.9238C187.479 17.3041 188.007 18.4855 188.859 19.3433C189.688 20.1782 190.869 20.6667 192.181 20.6667ZM184.837 20.6667C185.78 20.6667 186.456 20.377 186.746 20.1214V18.1561C186.524 18.3208 186.092 18.5197 185.524 18.5197C185.121 18.5197 184.831 18.4288 184.616 18.23C184.434 18.0483 184.343 17.7358 184.343 17.3212V9H181.94V11.4538H186.74V13.7826H181.94V17.9119C181.94 18.7469 182.196 19.4228 182.65 19.8943C183.162 20.394 183.911 20.6667 184.837 20.6667Z" fill="#4F008C"/>
                                    <path d="M236.5 22.5V5.5" stroke="#E8E8E8"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M271.946 12.5465C271.93 10.8797 273.356 10.0783 273.421 10.0395C272.619 8.9061 271.37 8.7507 270.925 8.7326C269.862 8.6286 268.851 9.3366 268.313 9.3366C267.774 9.3366 266.942 8.7479 266.06 8.7643C264.902 8.7803 263.834 9.4143 263.237 10.4155C262.034 12.4313 262.93 15.4173 264.102 17.0535C264.675 17.8531 265.359 18.754 266.256 18.7213C267.121 18.6882 267.448 18.1821 268.492 18.1821C269.537 18.1821 269.83 18.7213 270.744 18.7049C271.674 18.6882 272.264 17.8886 272.833 17.0862C273.491 16.1577 273.762 15.2591 273.777 15.2121C273.757 15.2036 271.965 14.5402 271.946 12.5465Z" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M269.994 7.7797C270.472 7.2202 270.795 6.4418 270.707 5.6665C270.017 5.6932 269.182 6.1103 268.688 6.6695C268.244 7.1647 267.856 7.9571 267.961 8.7169C268.73 8.7745 269.515 8.3396 269.994 7.7797ZM281.728 12.3364C281.129 12.8288 280.284 13.0751 279.194 13.0751C278.903 13.0751 278.631 13.0636 278.377 13.04C278.122 13.0167 277.892 12.9756 277.686 12.9172V7.6217C277.855 7.5866 278.08 7.5542 278.358 7.5249C278.637 7.4955 278.97 7.481 279.357 7.481C279.842 7.481 280.284 7.5367 280.684 7.648C281.084 7.7596 281.429 7.9236 281.719 8.1408C282.011 8.3588 282.242 8.6461 282.391 8.9763C282.549 9.3162 282.628 9.7153 282.628 10.1726C282.628 11.1225 282.327 11.8439 281.728 12.3364ZM283.255 8.7654C283.098 8.3889 282.867 8.0479 282.573 7.763C282.234 7.4463 281.802 7.2028 281.274 7.0328C280.748 6.8628 280.121 6.7778 279.394 6.7778C278.927 6.7755 278.46 6.7989 277.995 6.8479C277.606 6.8901 277.218 6.943 276.832 7.0065V18.7221H277.686V13.6559C278.074 13.7379 278.552 13.7787 279.121 13.7787C279.751 13.7787 280.332 13.7024 280.865 13.5503C281.398 13.3975 281.858 13.1658 282.246 12.8555C282.635 12.5439 282.948 12.1502 283.163 11.7033C283.388 11.2459 283.499 10.7123 283.499 10.1025C283.499 9.5982 283.418 9.1523 283.255 8.7654ZM289.199 15.6303C289.199 15.7336 289.168 15.8993 289.109 16.1283C289.036 16.3345 288.932 16.5341 288.794 16.7292C288.657 16.9232 288.487 17.0982 288.284 17.2521C288.08 17.4061 287.842 17.5291 287.567 17.6205C287.292 17.7126 286.981 17.758 286.635 17.758C286.205 17.758 285.816 17.6205 285.471 17.3462C285.124 17.0719 284.95 16.6427 284.95 16.0602C284.95 15.5681 285.088 15.1734 285.363 14.8761C285.637 14.5788 285.984 14.3531 286.402 14.1985C286.82 14.0446 287.277 13.944 287.773 13.8986C288.246 13.8535 288.722 13.8363 289.198 13.8473H289.199V15.6303ZM290.058 17.2952C290.046 16.9637 290.04 16.6318 290.04 16.3003L290.041 13.0579C290.04 12.6748 290.001 12.2928 289.924 11.9172C289.852 11.5455 289.702 11.1923 289.485 10.8792C289.27 10.5706 288.974 10.319 288.598 10.1246C288.221 9.9302 287.735 9.8332 287.137 9.8332C286.708 9.8316 286.28 9.8864 285.865 9.996C285.459 10.1046 285.064 10.2845 284.682 10.5358L284.951 11.1364C285.25 10.9417 285.581 10.7903 285.946 10.6818C286.31 10.5733 286.677 10.519 287.048 10.519C287.537 10.519 287.926 10.6048 288.213 10.7765C288.499 10.9479 288.714 11.1594 288.857 11.4107C288.999 11.6575 289.094 11.9279 289.136 12.2083C289.177 12.4882 289.199 12.7372 289.199 12.9549V13.1779C287.478 13.1549 286.19 13.4065 285.336 13.9328C284.481 14.459 284.054 15.208 284.054 16.1799C284.056 16.461 284.107 16.7396 284.207 17.0032C284.306 17.2744 284.462 17.5226 284.663 17.7324C284.866 17.9439 285.126 18.1152 285.443 18.2468C285.76 18.3784 286.128 18.4441 286.545 18.4441C286.857 18.447 287.168 18.4066 287.469 18.3241C287.749 18.2442 288 18.1383 288.221 18.0067C288.442 17.8751 288.636 17.7291 288.803 17.5692C288.971 17.4094 289.108 17.2495 289.215 17.089H289.252L289.377 18.2557H290.166C290.106 17.9465 290.07 17.6268 290.058 17.2952ZM291.638 10.1116L293.875 15.5589C294 15.8672 294.116 16.1786 294.224 16.4929C294.334 16.8129 294.432 17.1072 294.517 17.3746H294.554C294.64 17.1189 294.737 16.8307 294.847 16.5103C294.957 16.1906 295.08 15.8615 295.214 15.5234L297.305 10.1113H298.221L295.673 16.2575C295.44 16.8513 295.198 17.442 294.948 18.0294C294.742 18.517 294.513 18.9946 294.261 19.4609C294.05 19.8509 293.814 20.2272 293.554 20.5874C293.325 20.9032 293.057 21.1904 292.757 21.4427C292.415 21.7333 292.1 21.9462 291.812 22.0801C291.525 22.214 291.333 22.2984 291.235 22.3332L290.941 21.6523C291.192 21.5435 291.437 21.4212 291.675 21.2857C291.962 21.1207 292.227 20.9213 292.463 20.6922C292.684 20.4826 292.925 20.2067 293.188 19.8626C293.45 19.5195 293.686 19.1034 293.894 18.6143C293.967 18.4282 294.004 18.3056 294.004 18.2474C294.004 18.1664 293.967 18.0438 293.894 17.8808L290.721 10.1109L291.638 10.1116Z" fill="black"/>
                                    <path d="M324.5 22V6" stroke="#E8E8E8"/>
                                    <path d="M377.2 2.74272C375.925 1.28952 373.621 0.666504 370.672 0.666504H362.115C361.823 0.666344 361.541 0.770364 361.319 0.959834C361.097 1.1493 360.95 1.41178 360.904 1.70004L357.343 24.2985C357.326 24.4033 357.333 24.5105 357.362 24.6126C357.391 24.7148 357.441 24.8094 357.51 24.89C357.579 24.9707 357.665 25.0354 357.761 25.0798C357.858 25.1241 357.963 25.1471 358.069 25.147H363.351L364.678 16.7317L364.637 16.9952C364.682 16.7075 364.828 16.4453 365.049 16.2558C365.27 16.0663 365.552 15.962 365.843 15.9617H368.353C373.285 15.9617 377.146 13.9586 378.274 8.16399C378.308 7.99269 378.337 7.82589 378.362 7.66289C378.697 5.52119 378.359 4.06339 377.201 2.74348" fill="#003087"/>
                                    <path d="M377.2 2.74272C375.925 1.28952 373.621 0.666504 370.672 0.666504H362.115C361.823 0.666344 361.541 0.770364 361.319 0.959834C361.097 1.1493 360.95 1.41178 360.904 1.70004L357.343 24.2985C357.326 24.4033 357.333 24.5105 357.362 24.6126C357.391 24.7148 357.441 24.8094 357.51 24.89C357.579 24.9707 357.665 25.0354 357.761 25.0798C357.858 25.1241 357.963 25.1471 358.069 25.147H363.351L364.678 16.7317L364.637 16.9952C364.682 16.7075 364.828 16.4453 365.049 16.2558C365.27 16.0663 365.552 15.962 365.843 15.9617H368.353C373.285 15.9617 377.146 13.9586 378.274 8.16399C378.308 7.99269 378.337 7.82589 378.362 7.66289C378.697 5.52119 378.359 4.06339 377.201 2.74348" fill="#003087"/>
                                    <path d="M366.104 7.69083C366.144 7.43893 366.273 7.20953 366.467 7.04383C366.66 6.87813 366.907 6.78703 367.162 6.78673H373.871C374.665 6.78673 375.406 6.83853 376.083 6.94663C376.453 7.00623 376.82 7.08813 377.18 7.19193C377.589 7.30693 377.985 7.46473 378.361 7.66263C378.698 5.52013 378.36 4.06313 377.201 2.74244C375.925 1.29 373.621 0.666992 370.673 0.666992H362.115C361.824 0.667192 361.542 0.771372 361.32 0.960812C361.099 1.15025 360.952 1.41252 360.906 1.70053L357.343 24.2967C357.326 24.4015 357.333 24.5087 357.362 24.6108C357.39 24.713 357.441 24.8077 357.51 24.8884C357.579 24.9691 357.664 25.034 357.761 25.0784C357.857 25.1229 357.962 25.1459 358.068 25.1459H363.352L364.678 16.7298L366.104 7.69083Z" fill="#003087"/>
                                    <path d="M378.362 7.66211C378.336 7.82961 378.307 7.99671 378.275 8.16321C377.147 13.957 373.285 15.9608 368.354 15.9608H365.843C365.551 15.9611 365.27 16.0653 365.049 16.2549C364.828 16.4444 364.682 16.7067 364.638 16.9944L363.352 25.1454L362.986 27.4577C362.972 27.5495 362.977 27.6434 363.003 27.7328C363.028 27.8223 363.072 27.9052 363.133 27.9759C363.193 28.0465 363.268 28.1032 363.352 28.1421C363.437 28.181 363.529 28.2011 363.622 28.2011H368.075C368.602 28.2011 369.05 27.8172 369.133 27.297L369.176 27.07L370.016 21.7508L370.069 21.4568C370.109 21.2047 370.237 20.9752 370.431 20.8094C370.625 20.6437 370.872 20.5527 371.128 20.5527H371.794C376.108 20.5527 379.486 18.801 380.473 13.7315C380.884 11.6142 380.671 9.84491 379.582 8.60271C379.236 8.21761 378.823 7.89881 378.362 7.66211Z" fill="#009CDE"/>
                                    <path d="M377.18 7.19262C377.008 7.14162 376.83 7.09592 376.648 7.05552C376.465 7.01512 376.276 6.97932 376.083 6.94892C375.405 6.83842 374.664 6.78662 373.869 6.78662H367.162C366.906 6.78632 366.659 6.87742 366.465 7.04332C366.271 7.20932 366.143 7.43922 366.104 7.69152L364.678 16.7321L364.637 16.9948C364.681 16.7071 364.827 16.4449 365.048 16.2553C365.269 16.0658 365.551 15.9615 365.842 15.9613H368.353C373.284 15.9613 377.146 13.9582 378.274 8.16372C378.307 7.99232 378.335 7.82632 378.361 7.66252C378.063 7.50672 377.753 7.37572 377.434 7.27102C377.351 7.24362 377.266 7.21852 377.18 7.19262Z" fill="#012169"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_510_828">
                                    <rect width="381" height="29" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <Button inner={t("store.register.submit")+""} color="primary d-md-none d-block" isfullWidth={true} onClick={()=>{
                                const user = localStorage.getItem("tygo_user");
                                if(user && JSON.parse(user).token) {
                                    setState("card");
                                }
                                else
                                {
                                    setState("register");
                                }
                            }}/>
                            </div>
            </div> */}
            </div>


            <div className={"mt-5 " + (i18n.language === "en" ? "pe-md-5" : "ps-md-5")}>
            </div>
        </div>
        </div>
        <Footer />
        
        </>
    );
}
const RegisterForm = ({setState, setMethod, method} : {setState: any, setMethod: any, method: string}) => {
    const {t, i18n} = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [nameError, setNameError] = useState<string>("");
    const [phoneError, setPhoneError] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");
    const validateEmail = (email: string) => {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
    const [res, setRes] = useState<boolean>(false);
    const register = async () => {
        setRes(true);
        let a = false;
        if(name === "") {
            // setNameError("Name is required");
            setNameError(t("store.register.name_error") || "");
            a = true;
        }
        if(phone === "") {
            // setPhoneError("Phone is required");
            setPhoneError(t("store.register.phone_error") || "");
            a = true;
        }
        if(email === "") {
            // setEmailError("Email is required");
            setEmailError(t("store.register.email_error_required") || "");
            a = true;
        }
        if(!validateEmail(email)) {
            // setEmailError("Email is invalid");
            setEmailError(t("store.register.email_error_invalid") || "");
            a = true;
        }
        if(phone.length < 10) {
            // setPhoneError("Phone is invalid");
            setPhoneError(t("store.register.phone_error_invalid") || "");
            a = true;
        } 
        if(a)
            return;
        setLoading(true);
        await createAccount({
            email,
            phoneNumber:phone.toString().replace(/^0+/, ''),
            firstName:name.split(" ")[0],
            gander:"Male",
            countryCode: "966",
            registertionType: method,
        }).then((res) => {
            console.log(res);
            const user = {
                phoneNumber: phone,
                email,
                name,
                countryCode: "966",
            }
            localStorage.setItem("tygo_user", JSON.stringify(user));

            if(res.status === 200) {
                setState("otp");
            }
            
            setLoading(false);
        }
        ).catch(async (err) => {
            setError(err.response.data.Message);
            setLoading(true);
            await loginAccount({
                email,
                phoneNumber:phone.toString().replace(/^0+/, ''),
                countryCode: "966",
                logintType: method,
            })
            .then((res) => {
                console.log(res);
                const user = {
                    phoneNumber: phone,
                    email,
                    name,
                    countryCode: "966",
                }
                localStorage.setItem("tygo_user", JSON.stringify(user));
                if(res.status === 200) {
                    setState("otp");
                }
            }
            ).catch((err) => {
                setError(err.response.data.Message);
            });
            setLoading(false);
        }
        );
    }

    useEffect(() => {
        // const user = localStorage.getItem("tygo_user");
        // if(user) {
        //     setState("otp");
        // }
    }, []);



    return (
        <div className="card_form">
            <h1 className="my-4 d-none d-md-block">
                {t("store.register.title")}
            </h1>
            <h6 className=" d-block d-md-none">
                {t("store.register.title")}
            </h6>
            <div className="row payment_row my-3">
                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="">{t("store.register.name")}</label>
                        <input className={"form-control" + (nameError ? " is-invalid" : "")}
                         type="text" onChange={(e) => 
                        //  setName(e.target.value)
                            {
                                setName(e.target.value);
                                if(e.target.value === "" && res) {
                                    setNameError(t("store.register.name_error") || "");
                                }
                                else {
                                    setNameError("");
                                }
                            }
                         } />
                        {
                            nameError && <p className="text-danger">{nameError}</p>
                        }
                    </div>
                </div>
                <div className="col-md-12">
                <div className="form-group">
                        <label htmlFor="">{t("store.register.email")}</label>
                        <input className={"form-control" + (emailError ? " is-invalid" : "")}
                         type="email" onChange={(e) => 
                         {
                            setEmail(e.target.value);
                            // setEmailError("");
                            if(e.target.value === "" && res) {
                                setEmailError(t("store.register.email_error_required") || "");
                            }
                            else if(!validateEmail(e.target.value) && res) {
                                setEmailError(t("store.register.email_error_invalid") || "");
                            }
                            else {
                                setEmailError("");
                            }
                         }
                         } />
                        <p className="mb-0 m-2">
                            {t("store.register.email_info")}
                        </p>
                        {
                            emailError && <p className="text-danger">{emailError}</p>
                        }
                    </div>
                </div>
                <div className="col-md-12">
                <div className="form-group">
                        <label htmlFor="">{t("store.register.phone")}</label>
                        <input className={"form-control" + (phoneError ? " is-invalid" : "")}
                         type="tel" onChange={(e) => {
                            setPhone(e.target.value);
                            // setPhoneError("");
                            if(e.target.value === "" && res) {
                                setPhoneError(t("store.register.phone_error") || "");
                            }
                            else if(e.target.value.length < 10 && res) {
                                setPhoneError(t("store.register.phone_error_invalid") || "");
                            }
                            else {
                                setPhoneError("");
                            }
                        }
                        } />
                        {
                            phoneError && <p className="text-danger">{phoneError}</p>
                        }
                    </div>
                </div>
                {/* <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="">{t("store.register.method")}</label>
                        <div className="row">
                            <div className="col-md-6">
                                <label className="check_box my-2 d-flex align-items-center">
                                    <input type="radio" name="radio" 
                                    onChange={(e) => {setMethod("Email")}}
                                    value="Email"
                                    checked={method === "Email"}
                                    />
                                    <span className="mx-3">{t("store.register.method1")}</span>
                                </label>
                            </div>
                            <div className="col-md-6">
                                <label className="check_box my-2 d-flex align-items-center">
                                    <input type="radio" name="radio" 
                                    onChange={(e) => {setMethod("PhoneNumber")}}
                                    value="PhoneNumber"
                                    checked={method === "PhoneNumber"}
                                    />
                                    <span className="mx-3">{t("store.register.method2")}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div> */}

            </div>
            <p className=" pb-2 d-block">{t("store.register.info")}</p>
            <p className="text-danger">{error}</p>
            <Button inner={t("store.register.submit")}
             color=" primary" isfullWidth onClick={register} isLoading={loading} />
        </div>
    );
}
const OtpForm = ({setState, method} : {setState: any, method: string}) => {
    const {t, i18n} = useTranslation();
    const [error, setError] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [otp, setOtp] = useState(["", "", "", ""]);
    const inputRefs = useRef([...Array(4)].map(() => React.createRef())) as any;
    const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');

    const [counter, setCounter] = useState<number>(60);
    const handleOtpChange = (index: number, value: string) => {
      if (value === "") {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
  
        if (index > 0) {
          inputRefs.current[index - 1].current.focus();
        }
      } else if (+value >= 0 && +value <= 9) {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
  
        if (index < otp.length - 1) {
          inputRefs.current[index + 1].current.focus();
        }
      }
        if (index === otp.length - 1 && value !== "") {
            const otpValue = otp.join("");
            console.log(otpValue);
            const newOtp = [...otp];
            newOtp[index] = value;
         
            verify(newOtp.join(""));
        }
    };
    const [otptype, setOtpType] = useState<string>("PhoneNumber");
    const handleKeyDown = (index: number, e: any) => {
      if (e.key === "Backspace" && index > 0 && otp[index] === "") {
        e.preventDefault();
        setOtp((prevOtp) => {
          const newOtp = [...prevOtp];
          newOtp[index - 1] = "";
          return newOtp;
        });
        inputRefs.current[index - 1].current.focus();
      }
    };
    const verify = async (str: string) => {

        setLoading(true);
        await verifyCode(str, method,
            user.email,
            user.phoneNumber,
            user.countryCode
        ).then((res) => {
            console.log(res);
            if(res.status === 200) {
                const user = JSON.parse(localStorage.getItem("tygo_user")!);
                user.token = res.data.token;
                user.userId = res.data.userId;
                user.tokenExpiryDate = res.data.tokenExpiryDate;
                localStorage.setItem("tygo_user", JSON.stringify(user));
        
                setState("card");
            }
            setLoading(false);
        }
        ).catch((err) => {
            setError(err.response.data.Message);
            setLoading(false);
        }
        );
    }
    // Email
    const Resend = async (typw:string) => {
        const user = JSON.parse(localStorage.getItem("tygo_user")!);
        // createAccount({
        //     firstName:user.name.split(" ")[0],
        //     gander:"Male",
        //     countryCode: "966",
        //     email:user.email,
        //     phoneNumber:user.phoneNumber.toString().replace(/^0+/, ''),
        //     registertionType: typw,
        // })
        loginAccount({
                    email:user.email,
                    phoneNumber:user.phoneNumber.toString().replace(/^0+/, ''),
                    countryCode: "966",
                    logintType: typw,}).then(e=>{
                        toast.success(t("store.otp.message"));
                    })
                
        
        .then(e=>{
            toast.success(t("store.otp.message"));
        })
        .catch(
            (err) => {
                // loginAccount({
                //     email:user.email,
                //     phoneNumber:user.phoneNumber.toString().replace(/^0+/, ''),
                //     countryCode: "966",
                //     logintType: typw,}).then(e=>{
                //         toast.success(t("Otp Has been sent"));
                //     })
                // })
                // .catch((err) => {
                    setError(err.response.data.message);
                }
            );

    }

    useEffect(() => {
        const interval = setInterval(() => {
            setCounter((prev) => {
                if(prev === 0) {
                    clearInterval(interval);
                    return 60;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, []);


    return (
        <div className="card_form">
            <div className="form-group">
            
            <p>{t("store.otp.info")} {method === "PhoneNumber" ? user.phoneNumber : user.email}</p>
                <div className="my-3 otp_inputs">
                {otp.map((digit, index) => (
        <input
        //   autoFocus={index === 0 ? true : undefined}
        autoFocus={index === 0 ? true : undefined}
          key={index}
          type="tel"
          className="form-control"
          maxLength={1}
          value={digit}
          ref={inputRefs.current[index]}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onChange={(e) => handleOtpChange(index, e.target.value)}
        />
      ))}
            
                </div>
            </div>
            <p className="text-danger">{error}</p>
            <div className="row my-4">
                {/* <div className="col-md-6">
                    <Button inner={
                        (counter !== 60 ? counter.toString()+ " "+ t("store.otp.s_to")
                        : "")+ " "+ t("store.otp.resend")}
                         color="secondary" isfullWidth isDisabled={counter!==60}
                     onClick={()=>{
                        Resend("PhoneNumber");
                        const interval = setInterval(() => {
                            setCounter((prev) => {
                                if(prev === 0) {
                                    clearInterval(interval);
                                    return 60;
                                }
                                return prev - 1;
                            });
                        }, 1000);
                        return () => clearInterval(interval);
                        }}
                        />
                </div>
                <div className="col-md-6">
                    <Button inner={t("store.otp.to_email")}
                     color="secondary" isfullWidth onClick={()=>{
                        setOtpType("Email");
                        Resend("Email");
                    }} />
                </div> */}
            </div>
            <Button inner={t("store.otp.submit")}
             color="primary" isfullWidth onClick={
                () => {
                    const otpValue = otp.join("");
                    verify(otpValue);
                }
             }
             isLoading={loading} />
        </div>
    );

}
const CardForm = (
    {
        entityType, 
        // token,
        amount,
        email,
        street,
        city,
        state,
        country,
        postcode, 
        givenName,
        surname,
        phoneNumber,
        countryCode,
        // userId,
        paymentFor,
        promoCode,
        // redirectUrl,
        products,
        isMobile,
        isApp
    } : {
        entityType: string,
        // token: string,
        amount: number,
        email: string,
        street: string,
        city: string,
        state: string,
        country: string,
        postcode: string,
        givenName: string,
        surname: string,
        phoneNumber: string,
        countryCode: string,
        // userId: string,
        paymentFor: string,
        promoCode: string,
        // redirectUrl: string,
        products: any[],
        isMobile?: boolean,
        isApp?: boolean
    }
) => {
    const {t, i18n} = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const SendData =   async () => {
        setLoading(true);
        const baseUrl = window.location.origin+'/order/create';
        const user = JSON.parse(localStorage.getItem("tygo_user")!);
        const token = user.token;
        const userId = user.userId;
        
        const formData = new FormData();
        formData.append("entityType", entityType);
        formData.append("token", token);
        formData.append("amount", amount.toString());
        formData.append("email", email);
        formData.append("street", street);
        formData.append("city", city);
        formData.append("state", state);
        formData.append("country", country);
        formData.append("postcode", postcode);
        formData.append("givenName", givenName);
        formData.append("surname", surname);
        formData.append("phoneNumber", phoneNumber);
        formData.append("countryCode", countryCode);
        formData.append("userId", userId);
        formData.append("paymentFor", paymentFor);
        formData.append("redirectUrl", baseUrl);
        formData.append("products[0][quantity]", "1");
        formData.append("products[0][productId]", products[0].id);
        formData.append("prepaidOrEsim", "esim");
        formData.append("isTest", REACT_APP_API_PAYMENT === "https://test.pay.tygo.net" ? "true" : "false");
        formData.append("isMobile", isMobile ? "true" : "false");
        formData.append("promoCode", promoCode === null ? "123" : promoCode);
        formData.append("locale", i18n.language === "ar" ? "ar" : "en");
        var api_link = REACT_APP_API_PAYMENT;
        api_link += isMobile ? "/v2" : "";
        const response = await fetch(api_link, {
            method: "POST",
            body: formData
        });

        const iframe = document.getElementById("result-iframe") as HTMLIFrameElement;
        iframe.contentWindow!.document.open();
        iframe.contentWindow!.document.write(await response.text());
        iframe.contentWindow!.document.close();
        iframe.style.display = "block";
        setLoading(false);
}

    useEffect(() => {
        SendData();
        const order_details = {
            amount,
            qty: products.length,
        };
        localStorage.setItem("order_details", JSON.stringify(order_details));

    }, []);
    
    const navigate = useNavigate();
    const [showCancel, setShowCancel] = useState<boolean>(false);
    const handleCancel = () => {
        setShowCancel(false);
        navigate("/esims");
    }

    return (
        <div className="card_form">
            <div className=" d-none d-md-flex align-items-center" style={{gap:"32px"}}>
            <div onClick={() => setShowCancel(true)} className=" " style={{
                        cursor: "pointer"
            }}>
            <svg  width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform: (i18n.language === "ar" ? "scale(-1)" : "scale(1)")}}>
                    <path d="M15.95 31.3669C16.2666 31.3669 16.5833 31.2502 16.8333 31.0002C17.3166 30.5169 17.3166 29.7169 16.8333 29.2335L7.59997 20.0002L16.8333 10.7669C17.3166 10.2835 17.3166 9.48353 16.8333 9.0002C16.35 8.51686 15.55 8.51686 15.0666 9.0002L4.94996 19.1169C4.46663 19.6002 4.46663 20.4002 4.94996 20.8835L15.0666 31.0002C15.3166 31.2502 15.6333 31.3669 15.95 31.3669Z" fill="#292D32"/>
                    <path d="M6.1165 21.25H34.1665C34.8498 21.25 35.4165 20.6833 35.4165 20C35.4165 19.3167 34.8498 18.75 34.1665 18.75H6.1165C5.43317 18.75 4.8665 19.3167 4.8665 20C4.8665 20.6833 5.43317 21.25 6.1165 21.25Z" fill="#292D32"/>
                    </svg>
                </div><h1 className="my-4">{t("store.payment_details")}</h1>
            </div>
            <h6 className=" d-flex d-md-none align-items-center" style={{gap:"16px"}}>
            <div onClick={() => setShowCancel(true)} className=" " style={{
                        cursor: "pointer"
            }}>
            <svg  width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform: (i18n.language === "ar" ? "scale(-0.6)" : "scale(0.6)")}}>
                    <path d="M15.95 31.3669C16.2666 31.3669 16.5833 31.2502 16.8333 31.0002C17.3166 30.5169 17.3166 29.7169 16.8333 29.2335L7.59997 20.0002L16.8333 10.7669C17.3166 10.2835 17.3166 9.48353 16.8333 9.0002C16.35 8.51686 15.55 8.51686 15.0666 9.0002L4.94996 19.1169C4.46663 19.6002 4.46663 20.4002 4.94996 20.8835L15.0666 31.0002C15.3166 31.2502 15.6333 31.3669 15.95 31.3669Z" fill="#292D32"/>
                    <path d="M6.1165 21.25H34.1665C34.8498 21.25 35.4165 20.6833 35.4165 20C35.4165 19.3167 34.8498 18.75 34.1665 18.75H6.1165C5.43317 18.75 4.8665 19.3167 4.8665 20C4.8665 20.6833 5.43317 21.25 6.1165 21.25Z" fill="#292D32"/>
                    </svg>
                    </div>
                
                {t("store.payment_details")}</h6>
            {loading && <div className="d-flex justify-content-center align-items-center" style={{height: "100%"}}>
                    <Spinner />
                </div>}
                
            
            <iframe id="result-iframe" style={{display: "none", overflow:"hidden"}} width="100%" height="720px" className="mt-3"/>
            <Modal show={showCancel} onHide={() => setShowCancel(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("store.cancel")}</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
            <Button color="secondary" inner={t("store.no")} onClick={() => setShowCancel(false)} />
            <Button color="primary" inner={t("store.yes")} onClick={() => {
                handleCancel();
            }} />
        </Modal.Footer>
        </Modal>
        </div>
    );
}
const CardInfo = ({onEdit} : {onEdit: any}) => {
    const {t} = useTranslation();
    return (
        <div className="card_info">
            <div className="card_title d-flex justify-content-between">
                <span><strong>{t("store.payment")}
                     </strong> <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.6673 7.9987C14.6673 11.6806 11.6825 14.6654 8.00065 14.6654C4.31875 14.6654 1.33398 11.6806 1.33398 7.9987C1.33398 4.3168 4.31875 1.33203 8.00065 1.33203C11.6825 1.33203 14.6673 4.3168 14.6673 7.9987ZM8.00065 7.33203C8.36884 7.33203 8.66732 7.63051 8.66732 7.9987V11.3326C8.66732 11.7008 8.36884 11.9993 8.00065 11.9993C7.63246 11.9993 7.33398 11.7008 7.33398 11.3326V7.9987C7.33398 7.63051 7.63246 7.33203 8.00065 7.33203ZM8.00065 5.9987C8.36884 5.9987 8.66732 5.70022 8.66732 5.33203C8.66732 4.96384 8.36884 4.66536 8.00065 4.66536C7.63246 4.66536 7.33398 4.96384 7.33398 5.33203C7.33398 5.70022 7.63246 5.9987 8.00065 5.9987Z" fill="#3EB6AE"/>
                </svg></span>
            <span  color="text" onClick={onEdit} className="c-primary" style={{cursor:"pointer"}} > {t("store.edit")} </span>
            </div>
            <div className="mt-4 d-flex justify-content-between">
                <div className="d-flex gap-3">
            <img src="/media/svgs/visa.svg" alt="visa" />
            <div className="card_number">---- 6482</div>
                </div>
            <div className="card_name">01/25</div>
            </div>
        </div>
    );
}

export { CardInfo, RegisterForm, OtpForm};
export default Payment;
